import classNames from "classnames";
import { useTranslation } from "react-i18next";

import AwesomeIcon from "../AwesomeIcon";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface AlertProps {
  className: string;
  icon?: IconProp;
  onClick?: () => void;
  dynamicMessagePart?: Record<string, string>;
  messageKey: string;
  showProgress?: boolean;
}

function Alert({
  className,
  icon,
  onClick,
  dynamicMessagePart,
  messageKey,
  showProgress,
}: AlertProps) {
  const { t } = useTranslation();

  return (
    <>
      <div
        className={classNames(
          "bg-red-600 py-4 px-5 hidden sm:flex space-x-3 items-center text-base text-gray-100",
          { [className]: className }
        )}
        onClick={onClick}
      >
        {icon && <AwesomeIcon name={icon} />}
        <p>{t(messageKey, dynamicMessagePart)}</p>
      </div>
      {showProgress && (
        <div className=" bg-yellow-400 h-2 relative">
          <div className="w-[30%] bg-gradient-to-r h-2 absolute animate-moveBar from-transparent to-gray-800"></div>
        </div>
      )}
    </>
  );
}

export default Alert;
